import React from 'react';
import { useBrand } from '../context/BrandContext';

interface PoweredByProps {
  className?: string;
  logoColorOverride?: 'light' | 'dark' | 'auto';
  textColorOverride?: 'white' | 'black' | 'auto';
  isWelcomeView?: boolean; 
  showProvider?: boolean;
}

const PoweredBy: React.FC<PoweredByProps> = ({
  className = "",
  logoColorOverride = 'auto',
  textColorOverride = 'auto',
  isWelcomeView = false,
  showProvider = true,
}) => {
  const { isDarkMode } = useBrand();

  const getDividerColorClass = () => {
    if (isWelcomeView) {
      return 'bg-white/20';
    }
    if (textColorOverride === 'white') {
      return 'bg-white/20';
    }
    return 'bg-brand-text-primary/20';
  };

  const getLogoSrc = (logoType: 'pact' | 'pentatonic') => {
    const suffix = logoColorOverride === 'dark' || (logoColorOverride === 'auto' && isDarkMode) 
      ? '-wob.png'
      : '.png';
    return `/${logoType}${suffix}`;
  };

  const getTextColorClass = () => {
    if (textColorOverride === 'white') {
      return 'text-white';
    } else if (textColorOverride === 'black') {
      return 'text-black';
    }
    return 'text-brand-text-primary';
  };
  return (
    <div
      className={`box-border content-stretch flex flex-row gap-6 items-center justify-start p-0 ${className}`}
      data-node-id="73:802"
    >
      <div
        className="box-border content-stretch flex flex-row gap-6 items-center justify-start p-0 relative shrink-0"
        data-node-id="73:804"
      >
        {/* Pact Logo */}
        {showProvider && (
        <>
        <div
          className="bg-center bg-cover bg-no-repeat h-6 shrink-0 w-[81px]"
          data-name="pact logo"
          data-node-id="73:805"
        >
          <img 
            alt="Pact Logo" 
            className="w-full h-full object-contain" 
            src={getLogoSrc('pact')} 
          />
        </div>        
        <div className="flex flex-row items-center self-stretch">
          <div 
            className={`${getDividerColorClass()} shrink-0 w-[2px] h-[18px]`} 
            data-node-id="73:806"
          />
        </div>
        </>
        )}
        
        {/* Powered by text and Pentatonic logo */}
        <div
          className="box-border content-stretch flex flex-row gap-4 items-center justify-start p-0 relative shrink-0"
          data-node-id="284:5373"
        >
          <div
            className={`relative shrink-0 text-[18px] text-center text-nowrap tracking-[0.81px] uppercase font-brand-secondary leading-normal ${getTextColorClass()} `}
            data-node-id="284:5371"
            style={{ 
              fontFamily: 'var(--brand-font-button)'}}
          >
            <p className="block leading-normal whitespace-pre">powered by:</p>
          </div>
          
          {/* Pentatonic Logo */}
          <div className="h-4 relative shrink-0 w-[158px]" data-name="Pentatonic Logo" data-node-id="73:807">
            <div className="absolute flex inset-0 items-center justify-center">
              <div className="flex-none h-4 w-[157.986px]">
                <img 
                  alt="Pentatonic Logo" 
                  className="block max-w-none w-full h-full object-contain" 
                  src={getLogoSrc('pentatonic')} 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoweredBy;